import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { LayoutComponent } from './ui/layout/layout.component';
import { HomeComponent } from './home/home.component';
import { AuthGuardService } from './services/auth.guard.service';
import { ProfileComponent } from './profile/profile.component';
import { GroupDetailComponent } from './group/group-detail/group-detail.component';
import { UserResolver } from './services/user.resolver';
import { GroupResolver } from './services/group.resolver';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuardService],
    // resolve: { currentUser: UserResolver },
    children: [
      {
        path: '',
        component: HomeComponent,
        pathMatch: 'full',
        resolve: { currentUser: UserResolver },
      },
      {
        path: 'profile',
        component: ProfileComponent,
        resolve: { currentUser: UserResolver },
      },
      {
        path: 'g/:id',
        component: GroupDetailComponent,
        resolve: {
          currentUser: UserResolver,
          currentGroup: GroupResolver
        },
      }
    ]
  },
  { path: 'login', component: LoginComponent },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
